(() => {
  if (window.softServeCartGift) return;
  const first = document.querySelector('[data-cart-free-product]');
  if (!first) return;
  const config = first.dataset;
  const qualifying = new Set(config.qualifying.split(',').map(Number));
  const giftId = Number(config.productId), minimum = Number(config.minimum);
  const reminder = first.querySelector('[data-gift-reminder-template]')?.content.firstElementChild.cloneNode(true);
  if (reminder) {
    reminder.style.cssText = first.style.cssText;
    document.body.append(reminder);
  }
  const panels = () => [...document.querySelectorAll('[data-cart-free-product]'), ...(reminder ? [reminder] : [])];
  let queue = Promise.resolve(), busy = false, lastCart, checkoutApproved = false;
  let chosenVariant = '', manuallyChosen = false, pendingCheckout = null, checkingOut = false, skippedSignature = '';
  const count = cart => cart.items.reduce((sum, item) => sum + (qualifying.has(item.product_id) ? item.quantity : 0), 0);
  const gifts = cart => cart.items.filter(item => item.product_id === giftId);
  const claimed = cart => gifts(cart).some(item => item.final_line_price === 0);
  const signature = cart => cart.items.map(item => [item.key, item.quantity, item.final_line_price].join(':')).sort().join('|');
  function normalizeSize(value) {
    const key = String(value || '').toUpperCase().replace(/[\s-]/g, '');
    return ({SMALL:'S', MEDIUM:'M', LARGE:'L', XLARGE:'XL', '2X':'2XL', XXL:'2XL', '3X':'3XL', XXXL:'3XL'})[key] || key;
  }
  function suggestedVariant(cart, select) {
    const sizes = new Set();
    for (const item of cart.items.filter(item => qualifying.has(item.product_id))) {
      const size = item.options_with_values?.find(option => option.name.toLowerCase() === 'size')?.value;
      if (!size) return '';
      sizes.add(normalizeSize(size));
    }
    if (sizes.size !== 1) return '';
    return Array.from(select.options).find(option => option.value && !option.disabled && normalizeSize(option.dataset.size) === [...sizes][0])?.value || '';
  }
  async function request(path, body) {
    const response = await fetch(config.root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      ...(body ? {body: JSON.stringify(body)} : {}), signal: AbortSignal.timeout(12000)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || config.error);
    return result;
  }
  function showError(error) {
    panels().forEach(panel => {
      const message = panel.querySelector('[data-gift-error]');
      message.textContent = error.message || config.error;
      message.hidden = false;
    });
  }
  function clearError() {
    panels().forEach(panel => { panel.querySelector('[data-gift-error]').hidden = true; });
  }
  function render(cart) {
    lastCart = cart;
    const remaining = Math.max(0, minimum - count(cart));
    const hasGift = claimed(cart);
    const select = first.querySelector('[data-gift-size]');
    if (!manuallyChosen) chosenVariant = suggestedVariant(cart, select);
    if (!Array.from(select.options).some(option => option.value === chosenVariant && !option.disabled)) {
      chosenVariant = ''; manuallyChosen = false;
    }
    panels().forEach(panel => {
      const picker = panel.querySelector('[data-gift-size]');
      picker.value = chosenVariant;
      const available = Array.from(picker.options).some(option => option.value && !option.disabled);
      panel.querySelector('[data-gift-status]').textContent = hasGift ? config.added : !available ? config.soldOut : remaining ? config.locked.replace('[remaining]', remaining) : config.ready;
      panel.querySelector('[data-gift-controls]').hidden = remaining > 0 || hasGift || !available;
      panel.querySelector('[data-gift-add]').disabled = busy || !picker.value || remaining > 0 || hasGift;
      panel.querySelector('[data-gift-skip]')?.toggleAttribute('disabled', busy);
    });
  }
  function schedule(task) { const next = queue.catch(() => {}).then(task); queue = next; return next; }
  async function reconcile() {
    if (window.softServeSaleCartReady) await window.softServeSaleCartReady;
    let cart = await request('cart.js');
    const updates = {}; let kept = false;
    for (const item of gifts(cart)) {
      const paidClaim = item.properties?._offer === 'cart-gift' && item.final_line_price !== 0;
      const quantity = count(cart) >= minimum && !kept && !paidClaim ? 1 : 0;
      kept = kept || quantity === 1;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', {updates});
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
    const firstRefresh = !lastCart;
    render(cart);
    if (firstRefresh) document.dispatchEvent(new CustomEvent('cart:build'));
    return cart;
  }
  function refresh() { schedule(reconcile).catch(showError); }
  function resumeCheckout(intent) {
    if (!intent) return;
    pendingCheckout = null;
    reminder?.close();
    checkoutApproved = true;
    try {
      if (intent.fromClick && intent.submitter?.isConnected) intent.submitter.click();
      else if (intent.submitter?.isConnected) intent.form.requestSubmit(intent.submitter);
      else intent.form.requestSubmit();
    } finally { checkoutApproved = false; }
  }
  function openReminder(intent, cart) {
    if (!reminder || typeof reminder.showModal !== 'function') {
      resumeCheckout(intent);
      return;
    }
    pendingCheckout = intent;
    if (cart) render(cart);
    if (!reminder.open) reminder.showModal();
    const select = reminder.querySelector('[data-gift-size]');
    (select.closest('[data-gift-controls]').hidden ? reminder.querySelector('[data-gift-skip]') : select).focus();
  }
  function attemptCheckout(intent) {
    if (checkingOut || busy) return;
    checkingOut = true;
    clearError();
    schedule(reconcile).then(cart => {
      if (count(cart) >= minimum && !claimed(cart) && skippedSignature !== signature(cart)) openReminder(intent, cart);
      else resumeCheckout(intent);
    }).catch(error => {
      openReminder(intent, lastCart);
      showError(error);
    }).finally(() => { checkingOut = false; });
  }
  function checkoutForm(form, submitter) {
    if (!form || form.tagName !== 'FORM') return false;
    const path = new URL(form.action, location.href).pathname;
    return /\/checkout\/?$/.test(path) || (/\/cart\/?$/.test(path) && submitter?.name === 'checkout');
  }
  // Run before third-party checkout click handlers; replay the original click after the choice.
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (checkoutApproved || !button || !checkoutForm(button.form, button)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    attemptCheckout({form: button.form, submitter: button, fromClick: true});
  }, true);
  document.addEventListener('submit', event => {
    if (checkoutApproved || !checkoutForm(event.target, event.submitter)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    attemptCheckout({form: event.target, submitter: event.submitter, fromClick: false});
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-gift-size]')) return;
    chosenVariant = event.target.value;
    manuallyChosen = true;
    if (lastCart) render(lastCart);
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-gift-back]')) {
      pendingCheckout = null; reminder.close(); return;
    }
    if (event.target.closest('[data-gift-skip]')) {
      if (busy) return;
      if (lastCart) skippedSignature = signature(lastCart);
      resumeCheckout(pendingCheckout); return;
    }
    const button = event.target.closest('[data-gift-add]');
    if (!button || button.disabled || busy) return;
    event.preventDefault();
    const panel = button.closest('[data-cart-free-product], [data-gift-reminder]');
    const variantId = Number(panel.querySelector('[data-gift-size]').value);
    const intent = button.hasAttribute('data-gift-checkout') ? pendingCheckout : null;
    if (!variantId) return;
    busy = true; if (lastCart) render(lastCart);
    clearError();
    schedule(async () => {
      const cart = await reconcile();
      if (count(cart) < minimum) return;
      if (claimed(cart)) { if (intent) resumeCheckout(intent); return; }
      if (gifts(cart).length) throw new Error(config.error);
      await request('cart/add.js', {items: [{id: variantId, quantity: 1, properties: {_offer: 'cart-gift'}}]});
      const updated = await request('cart.js');
      const gift = gifts(updated).find(item => item.variant_id === variantId);
      if (!gift || gift.final_line_price !== 0) {
        if (gift) render(await request('cart/update.js', {updates: {[gift.key]: 0}}));
        document.dispatchEvent(new CustomEvent('cart:build'));
        throw new Error(config.error);
      }
      render(updated);
      document.dispatchEvent(new CustomEvent('cart:build'));
      if (intent) resumeCheckout(intent);
    }).catch(showError).finally(() => { busy = false; if (lastCart) render(lastCart); });
  });
  reminder?.addEventListener('cancel', () => { pendingCheckout = null; });
  ['cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(name => document.addEventListener(name, refresh));
  window.addEventListener('pageshow', () => { checkoutApproved = false; checkingOut = false; });
  window.softServeCartGift = {refresh}; refresh();
})();
